export type PushTemplateRow = {
  _id?: string;
  code?: string;
  name?: string;
  channel?: string;
  subject?: string;
  body?: string;
  variables?: string[];
  isActive?: boolean;
  issues?: string[];
  complete?: boolean;
  delivery?: 'live' | 'not_sent' | 'unknown_event';
  eventLabel?: string | null;
};

export const PUSH_TEMPLATE_SAMPLE_VARS: Record<string, Record<string, string>> = {
  ride_accepted: { rideNumber: 'RIDE-1024' },
  ride_arrived: { rideNumber: 'RIDE-1024' },
  ride_started: { rideNumber: 'RIDE-1024' },
  ride_completed: { rideNumber: 'RIDE-1024', fareTotal: '249.00', currency: '₹' },
  auth_login: { firstName: 'Ravi' },
  auth_register: { firstName: 'Ravi' },
  auth_otp_verified: { purpose: 'login' },
  partner_documents_approved: { entityType: 'driver' },
  partner_document_approved: { documentLabel: 'Driving Licence' },
  partner_document_rejected: {
    documentLabel: 'Driving Licence',
    reason: 'Image is blurry. Please upload a clear photo.',
  },
  partner_documents_rejected: {
    entityType: 'driver',
    reason: 'Some documents were rejected. Please re-upload to continue.',
  },
  order_confirmed: { orderNumber: 'ORD-5521' },
  otp_sms: { otp: '4821' },
  ride_offer: { rideNumber: 'RIDE-2048' },
  order_offer: { orderNumber: 'ORD-8891' },
  food_order_placed: { orderNumber: 'ORD-5521' },
  food_order_confirmed: { orderNumber: 'ORD-5521' },
  food_order_preparing: { orderNumber: 'ORD-5521' },
  food_order_ready: { orderNumber: 'ORD-5521' },
  food_order_picked_up: { orderNumber: 'ORD-5521' },
  food_order_delivering: { orderNumber: 'ORD-5521' },
  food_order_delivered: { orderNumber: 'ORD-5521' },
  food_order_cancelled: { orderNumber: 'ORD-5521' },
  food_order_refunded: { orderNumber: 'ORD-5521' },
  grocery_order_placed: { orderNumber: 'GRO-3301' },
  grocery_order_confirmed: { orderNumber: 'GRO-3301' },
  grocery_order_delivered: { orderNumber: 'GRO-3301' },
};

export function defaultSampleVars(code: string, variables: string[] = []): Record<string, string> {
  const base = { ...(PUSH_TEMPLATE_SAMPLE_VARS[code] ?? {}) };
  for (const key of variables) {
    if (base[key] == null) {
      base[key] = key === 'firstName' ? 'Ravi' : `sample_${key}`;
    }
  }
  if (base.firstName == null && variables.includes('firstName')) base.firstName = 'Ravi';
  if (base.reason == null && variables.includes('reason')) {
    base.reason = 'Sample rejection reason for preview.';
  }
  return base;
}

export function interpolatePushTemplate(
  template: string,
  vars: Record<string, string>,
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => vars[key] ?? '');
}

export function previewPushTemplate(
  row: PushTemplateRow,
  vars: Record<string, string>,
): { title: string; body: string } {
  const title = interpolatePushTemplate(row.subject || row.name || row.code || 'Notification', vars);
  const body = interpolatePushTemplate(row.body || '', vars);
  return { title, body };
}
